import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _dec, _dec2, _class;
// TODO: Use reselect! Create a getQuizzes selector that can be used for reselecting quizzes by id
import { Map, List } from 'immutable';
import { getActiveQuizSession } from './quizSessions';
import Quiz from '../records/Quiz';
import QuizEntry from '../records/QuizEntry';
import { QUIZ_ENTRY_GUID_SUFFIX, TEMPORARY_ITEM_ID, TEMPORARY_QUIZ_ENTRY_ID } from '@instructure/quiz-common';
import withStateCache from '../util/withStateCache';
import reduxStore from '../../reduxStore';
var path = 'quizzes';
export var getActiveQuiz = function getActiveQuiz(state) {
  return getQuizById(state, getActiveQuizId(state));
};
export var getActiveQuizId = function getActiveQuizId(state) {
  // For some reason this could be defined in one or the other of these, or neither.
  return state.getIn([path, 'activeQuizId']) || getActiveQuizSession(state) && getActiveQuizSession(state).get('quiz');
};
export var getActiveQuizCaluclatorType = function getActiveQuizCaluclatorType(state) {
  return state.getIn([path, getActiveQuizId(state), 'calculatorType']);
};
export var getQuizById = function getQuizById(state, id) {
  return Quiz.create(state.getIn([path, id]));
};
export var getTotalPointsPossible = function getTotalPointsPossible(state, quizId) {
  var quizEntries = getQuizEntriesByQuizId(state, quizId);
  return quizEntries.reduce(function (total, entry) {
    return total + (entry.isBank ? entry.bankPointsPossible : entry.pointsPossible);
  }, 0);
};
export var getQuizEntriesByQuizId = function getQuizEntriesByQuizId(state, quizId) {
  var quiz = getQuizById(state, quizId);
  return getQuizEntriesByIds(state, quiz.get('quizEntries', List()));
};
export var getQuizEntriesByIds = function getQuizEntriesByIds(state) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ids.reduce(function (list, id) {
    var quizEntry = getQuizEntryById(state, id);
    return quizEntry ? list.push(quizEntry) : list;
  }, List());
};
export var getQuizEntryById = function getQuizEntryById(state, id) {
  if (id === TEMPORARY_QUIZ_ENTRY_ID) {
    return getTemporaryQuizEntry(state);
  }
  return QuizEntry.create(state.getIn(['quizEntries', id]));
};
export var getTemporaryQuizEntry = function getTemporaryQuizEntry(state) {
  var temporaryQuizEntryData = state.getIn(['modifications', 'quizEntries', TEMPORARY_QUIZ_ENTRY_ID], Map({
    entry: TEMPORARY_ITEM_ID
  }));
  return QuizEntry.create(temporaryQuizEntryData);
};
export var isActiveQuizWorkingInstanceOneQuestionAtATime = function isActiveQuizWorkingInstanceOneQuestionAtATime(state) {
  return getActiveQuiz(state).getWorkingInstance().isOneQuestionAtATime();
};
var CacheHelper = (_dec = withStateCache(function () {
  return [['quizEntries'], ['modifications', 'quizEntries'], ['modifications', 'items'], ['modifications', 'stimuli'], ['editing']];
}), _dec2 = withStateCache(function () {
  return [['editing']];
}), _class = /*#__PURE__*/function () {
  function CacheHelper() {
    _classCallCheck(this, CacheHelper);
  }
  return _createClass(CacheHelper, [{
    key: "state",
    value:
    // This is needed for withStateCache to work properly :-/
    function state() {
      return reduxStore.getAppState();
    }
  }, {
    key: "__isShowingErrors",
    value: function __isShowingErrors(state, quizEntry) {
      var isInvalid = !quizEntry.getEntry().getWorkingInstance().isValid();
      var isEditing = state.getIn(['editing', "".concat(quizEntry.id, "_").concat(QUIZ_ENTRY_GUID_SUFFIX)]);
      return isInvalid && isEditing;
    }
  }, {
    key: "quizEntryWithErrorsShowing",
    value: function quizEntryWithErrorsShowing(state) {
      var _this = this;
      var qeWithErrors = state.get('quizEntries').find(function (qe) {
        return _this.__isShowingErrors(state, QuizEntry.create(qe));
      });
      if (qeWithErrors) {
        return qeWithErrors;
      }
      var temp = getTemporaryQuizEntry(state);
      if (this.__isShowingErrors(state, temp)) {
        return temp;
      }
    }
  }, {
    key: "editingQuizEntry",
    value: function editingQuizEntry(state) {
      return state.get('editing', []).find(function (isEditing, key) {
        return isEditing && key.includes(QUIZ_ENTRY_GUID_SUFFIX);
      });
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "quizEntryWithErrorsShowing", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "quizEntryWithErrorsShowing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editingQuizEntry", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "editingQuizEntry"), _class.prototype), _class);
var cacheHelper = new CacheHelper();

// This is a hack to continue using withStateCache until we implement reselect
export var getQuizEntryWithErrorsShowing = cacheHelper.quizEntryWithErrorsShowing.bind(cacheHelper);
export var isEditingQuizEntry = cacheHelper.editingQuizEntry.bind(cacheHelper);